<div class="table-responsive">
  <table class="table align-items-center table-flush">
    <thead class="thead-light">
    <tr>
      <th scope="col">Report Type</th>
      <th scope="col">Due Date</th>
      <th scope="col"></th>
    </tr>
    </thead>

    <tbody class="list">
    <tr *ngFor="let item of reportDue; index as i">
      <td>
        {{ item.name }}
      </td>
      <td>
        <span class="mr-4 text-wrap">
          <span class="status ">{{ item.dueDate|date :'dd/MM/YYYY' }}</span>
        </span>
      </td>
      <td >
        <div *ngIf="!this.isReadOnly">
          <button *ngIf="item.requireAction" class="btn btn-info btn-sm" (click)="navigateToSubmitReport(item)">
            <i class="fa fa-file-alt"></i> Fill in
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>



